import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  // Show a loading spinner while checking authentication
  if (loading) {
    return <div className="text-center my-5">Loading...</div>; // Or replace with a spinner component
  }

  // If not authenticated, redirect to the register/login page
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  // Render the protected component if authenticated
  return children;
};

export default PrivateRoute;
